module.exports = __webpack_public_path__ + "img/wine.8368d8fe.png";